<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="attachmentPreview">
            <van-nav-bar
                title="附件预览"
                left-text="合同详情"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <iframe :src="src" frameborder="0"></iframe>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 附件预览
    name: 'attachment-preview',
    components: {},
    props: {},
    data() {
        return {
            // 附件地址
            src: '',
        };
    },
    computed: {},
    watch: {},
    created() {
        this.src = this.$route.params.url;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({
                name: 'contractDetails',
            });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({
                name: 'contractDetails',
            });
        },
    },
};
</script>
<style lang="stylus" scoped>
.attachmentPreview
    height 100%
    section
        height calc(100% - 45rpx)
        iframe
            width 100%
            height 100%
</style>